"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_) {
  return null;
}

var _default = Column;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/sugar/Column.js
// module id = 1060
// module chunks = 0